/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {NbWindowService} from '@nebular/theme';
import {BaseComponent, Document, DocumentPosition, FileService, InputFile} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {catchError, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {CrudEvent} from '../../interfaces/crud-event';

export interface CertificateFile {
  file: File;
}

@Component({
  selector: 'app-certificates-uploader',
  templateUrl: './certificates-uploader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CertificatesUploaderComponent extends BaseComponent implements OnChanges {

  @Input() model: any;
  @Input() uri: string;
  @Output() loadingEvent = new EventEmitter<CrudEvent>();
  uploadURI: string;
  showUploadForm = false;

  constructor(protected readonly windowService: NbWindowService,
              protected readonly fileService: FileService) {
    super();
  }

  ngOnChanges() {
    if (this.model) {
      this.uploadURI = this.uri + '/upload-certificate';
    }
  }

  onUpload(files: InputFile[]) {
    this.loadingEvent.emit(CrudEvent.UPLOADING);

    this.loading = true;
    this.compoApiService
      .postForm<CertificateFile, string>(this.uploadURI, {file: files[0].file})
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(resp => {
          this.loadingEvent.emit(CrudEvent.UPLOADING_DONE);

          this.model.certificates.push(resp.data);
          this.cdr.detectChanges();
        }),
      ).subscribe();
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.model.certificates, event.previousIndex, event.currentIndex);
    this.model.certificates.forEach((value, idx) => value.pos = idx);
    this.updateCertificatesPositions();
  }

  updateCertificatesPositions() {
    const uri = this.uri + '/certificates';
    const certificatePositions: DocumentPosition[] = [];
    this.model.certificates.forEach(certificate => certificatePositions.push({id: certificate.id, pos: certificate.pos}));
    this.compoApiService.post(uri, certificatePositions).pipe(takeUntil(this.unsubscribe)).subscribe(_ => {
    });
  }

  download(certificate: Document) {
    this.fileService
      .downloadUrl(this.fileService.getPublicDocumentUri(certificate.fileName))
      .subscribe(response => {
        FileService.saveAs(response, certificate.fileName);
      });
  }

  removeDialog(certificate: Document) {
    this.confirm(translations.confirmDelete + ' ' + translations.file.toLowerCase() + '?', new Observable(() => {
      this.removeCertificate(certificate);
    }));
  }

  removeCertificate(certificate: Document) {
    const uri = this.uri + '/certificate/' + certificate.id;
    this.compoApiService.delete<Document>(uri)
      .pipe(
        take(1),
        catchError(error => this.handleError(error)),
        tap(_ => {
          const index = this.model.certificates.findIndex(el => el.id == certificate.id);
          this.model.certificates.splice(index, 1);
          this.cdr.detectChanges();

        }),
      ).subscribe();
  }
}
